import { render, staticRenderFns } from "./HistoryJobModal.vue?vue&type=template&id=2244dc26&scoped=true"
import script from "./HistoryJobModal.vue?vue&type=script&lang=js"
export * from "./HistoryJobModal.vue?vue&type=script&lang=js"
import style0 from "./HistoryJobModal.vue?vue&type=style&index=0&id=2244dc26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2244dc26",
  null
  
)

export default component.exports